import { Outlet, useLocation } from "react-router";
import { Trans } from "@lingui/react/macro";
import { useAuth } from "@/auth/use-auth";
import { redirectToLogin } from "@/auth/auth";

/**
 * Route guard for admin users.
 *
 * Renders child routes if the user is authenticated and has admin privileges.
 * Redirects to login if not authenticated.
 * Shows access denied message if authenticated but not admin.
 */
export function AdminRoute() {
  const { user, isLoading, isAdmin } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Trans>Loading...</Trans>
      </div>
    );
  }

  if (!user) {
    redirectToLogin(location.pathname);
    return null;
  }

  if (!isAdmin) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-4">
        <h1 className="text-2xl font-bold">
          <Trans>Access Denied</Trans>
        </h1>
        <p>
          <Trans>You don't have permission to access this page.</Trans>
        </p>
      </div>
    );
  }

  return <Outlet />;
}
